/**
 * Shared visual language for the Advertising module.
 *
 * These were originally local to pages/Advertising.js. The Commercial Breaks
 * panel needs the exact same status pill and segmented toggle, so they live
 * here rather than being copied (and drifting) in two places.
 */
import React from 'react';
import { Box, Chip } from '@mui/material';

// Campaign/break status palette. Unknown statuses fall back to muted grey.
export const STATUS_STYLES = {
  active: { color: '#4ade80', bg: 'rgba(74,222,128,0.12)', border: 'rgba(74,222,128,0.35)' },
  scheduled: { color: '#7dd3fc', bg: 'rgba(125,211,252,0.10)', border: 'rgba(125,211,252,0.35)' },
  paused: { color: '#fbbf24', bg: 'rgba(251,191,36,0.12)', border: 'rgba(251,191,36,0.35)' },
  completed: { color: '#a5b4fc', bg: 'rgba(165,180,252,0.10)', border: 'rgba(165,180,252,0.30)' },
  inactive: { color: 'var(--rs-muted)', bg: 'rgba(148,163,184,0.10)', border: 'rgba(148,163,184,0.28)' },
};

export const getStatusStyle = (status) =>
  STATUS_STYLES[status] || { color: 'var(--rs-muted)', bg: 'rgba(148,163,184,0.10)', border: 'rgba(148,163,184,0.30)' };

export const StatusChip = ({ status, label }) => {
  const s = getStatusStyle(status);
  return (
    <Chip
      label={label || status}
      size="small"
      icon={<Box component="span" sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: s.color, boxShadow: `0 0 8px ${s.color}` }} />}
      sx={{
        color: s.color,
        bgcolor: s.bg,
        border: `1px solid ${s.border}`,
        textTransform: 'capitalize',
        fontSize: '0.72rem',
        height: 24,
        '& .MuiChip-icon': { ml: '9px', mr: '-3px' },
      }}
    />
  );
};

// Segmented pill toggle shared by the Campaigns and Commercial Breaks toolbars.
export const segmentedToggleSx = {
  bgcolor: 'rgba(148,163,184,0.06)',
  border: '1px solid rgba(148,163,184,0.14)',
  borderRadius: '10px',
  p: '3px',
  gap: '2px',
  '& .MuiToggleButton-root': {
    color: '#8b98ab',
    border: 'none',
    borderRadius: '8px !important',
    px: 1.5,
    py: 0.5,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.8rem',
  },
  '& .MuiToggleButton-root.Mui-selected': {
    color: '#04222b',
    backgroundImage: 'linear-gradient(180deg, #4fdcf3 0%, #17b5d8 100%)',
    boxShadow: '0 2px 10px -2px rgba(34,211,238,0.5)',
    '&:hover': { backgroundImage: 'linear-gradient(180deg, #67e8f9 0%, #22d3ee 100%)' },
  },
};
